<template>
	<div class="new-index">
		<IndexSocket ref="robotSocketRef" :nowTime='nowTime' @backSockertData='doSocker($event)' />

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text">运行信息</div>
			<div style="width: 100%;height: 80px;top: 0;left: 0;display: flex;align-items: center;justify-content: center;">
				<div class="phone-numberli">{{ funReal < 5 ? 0 : parseInt((funNum % 1000000000)/100000000) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 100000000)/10000000) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 10000000)/1000000) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 1000000)/100000) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 100000)/10000) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 10000)/1000) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 1000)/100) }}</div>
				<div class="phone-numberli">{{ parseInt((funNum % 100)/10) }}</div>
				<div class="phone-numberli">{{ parseInt(funNum % 10) }}</div>
			</div>
			<div class="phone-text">运行时长（小时）</div>
		</div>

		<div style="padding: 10px 0;">
			<div class="phone-text">报警统计 & 机器人数量</div>
			<div style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;border-bottom: 2px solid #02314d;">
				<div style="display: flex;align-items: center;justify-content: center;margin: 0 10px;width: 50%;">
					<img :src="error_ul" style="width: 50px;margin: 0 10px;">
					<span style="font-size: 16px;color: rgb(18,150,219);font-weight: 600;width: 100px;">总数：<span
							style="font-weight: 900;">{{ errorData.totalNum }}</span></span>
				</div>
				<div style="display: flex;align-items: center;justify-content: center;margin: 0 10px;width: 50%;">
					<img :src="error_li" style="width: 50px;margin: 0 10px;">
					<span style="font-size: 16px;color: rgb(18,150,219);font-weight: 600;width: 100px;">总数：<span
							style="font-weight: 900;">{{ errorData.untreatedNum }}</span></span>
				</div>
			</div>

			<div style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;border-bottom: 2px solid #02314d;">
				<div style="display: flex;align-items: center;justify-content: center;margin: 0 10px;width: 50%;">
					<img :src="robot_li" style="width: 50px;margin: 0 10px;">
					<span style="font-size: 16px;color: rgb(18,150,219);font-weight: 600;width: 100px;">总数：<span
							style="font-weight: 900;">{{ errorObj.totalNum }}</span></span>
				</div>
				<div style="display: flex;align-items: center;justify-content: center;margin: 0 10px;width: 50%;">
					<img :src="robot_ul" style="width: 50px;margin: 0 10px;">
					<span style="font-size: 16px;color: rgb(18,150,219);font-weight: 600;width: 100px;">在岗：<span
							style="font-weight: 900;">{{ errorObj.onDuty }}</span></span>
				</div>
			</div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text" style="margin-bottom: 20px;">实时报警</div>
			<div class="phone-table-ul">
				<div style="width: 25%;text-align: center;">时间</div>
				<div style="width: 25%;text-align: center;">上报机器</div>
				<div style="width: 25%;text-align: center;">上报内容</div>
				<div style="width: 25%;text-align: center;">处理状态</div>
			</div>
			<div class="phone-table-body">
				<div v-for="(obj, index) in eventAry" :key="index"
					:class="obj.results === '1' ? 'body-li' : 'body-li error-li'">
					<div>{{ obj.insDate }}</div>
					<div>{{ obj.rName }}</div>
					<div class="text">{{ obj.eName }}</div>
					<div class="text">{{ obj.resultsName }}</div>
				</div>
			</div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text" style="margin-bottom: 20px;">机器人</div>
			<div style="width: 100%;display: inline-block;" class="robot-body">
				<div v-for="(obj, index) in robotAry" :key="index">
					<span>{{ obj.robotName }}</span>
					<span>{{ obj.routeName }}</span>
					<span>{{ obj.onlineStatus === '1' ? obj.ststusName : '离线'}}</span>
				</div>
			</div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div style="width: 100%;height: 200px;" id="body-li0"></div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text" style="margin-bottom: 20px;">地图事件数据分析</div>
			<div style="width: 100%;height: 200px;" id="body-li2"></div>
			<div style="width: 100%;height: 200px" id="body-li2-2"></div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text" style="margin-bottom: 20px;">事件数据分析</div>
			<div style="width: 100%;height: 200px;" id="body-li3"></div>
			<div style="width: 100%;height: 200px;" id="body-li3-2"></div>
		</div>

		<div style="padding: 10px 0;width: 90%;margin: 0 auto;">
			<div class="phone-text" style="margin-bottom: 20px;">地图详情</div>
			<div style="width: 100%;height: 300px;">
				<div class="center-bottom" style="display: block;" ref="adressWrap">

					<div class="map-btn" style="margin-bottom: 20px;">
						<el-button type="primary" icon="el-icon-sort"
							style="margin-bottom: 0px;-moz-transform:rotate(-90deg);-webkit-transform:rotate(-90deg);"
							circle @click="ifMapList=!ifMapList"></el-button>
						<el-button type="success" icon="el-icon-zoom-in" circle @click="mapScale += 0.1"></el-button>
						<el-button type="danger" icon="el-icon-zoom-out" circle @click="mapScale -= 0.1"></el-button>
					</div>

					<div style="width: 100%;height: 100%;overflow: scroll;">
						<div class="content-div-check" style="margin: 0 auto;"
							:style="{ width: vWidth + 'px', height: vHeight + 'px', zoom: mapScale}">
							<img :src="backUrl" />
							<!-- <div class="robot" ref="robot" v-for="(obj, index) in mapRobotAry" :key="index">
								<div style="white-space: nowrap;">{{ obj.number }}</div>
							</div> -->
						</div>
					</div>

					<el-button type="info" v-if="mapAry.length > 4 && ifMapList"
						style="position: absolute;left: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;" circle
						@click="mapScroll('left')">
						<i class="el-icon-caret-left" style="font-size: 25px;"></i>
					</el-button>

					<el-button type="info" v-if="mapAry.length > 4 && ifMapList"
						style="position: absolute;right: 60px;bottom: 60px;padding: 6px;opacity: 0.5;z-index: 99;"
						circle @click="mapScroll('right')">
						<i class="el-icon-caret-right" style="font-size: 25px;"></i>
					</el-button>

					<transition name="el-zoom-in-bottom">
						<div v-show="ifMapList" class="changeImage">
							<div class="img-li" v-for="(item, index) in mapAry" :key="index"
								@click="getMapDetail(index)"
								:style="{backgroundColor: item.check ? '#2b4490' : 'transparent'}">
								<div class="img-tltle" style="margin-bottom: 10px;">{{ item.rName }}</div>
								<el-image style="width: 100px; height: 100px" :src="item.address" fit="scale-down">
								</el-image>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped lang="less"></style>

<script>
	import {
		allEventStatistics,
		mapList,
		robotList,
		eventList,
		robotNum,
		eventChart,
		mapEventChart,
		positonList,
		mapEventLineChart,
		eventLineChart,
		handleTime,
		runTime
	} from '@/api/index'
	import {
		getToken,
		getItem,
		setToken
	} from '@/utils/auth'
	import IndexSocket from '@/components/IndexSocket.vue'
	import '@/page/newIndex/index/index.less'
	import '@/page/phone/index1.less'

	export default {
		name: 'phone1',
		components: {
			IndexSocket
		},
		data() {
			return {
				newTime: new Date(),
				nowTime: new Date().getTime(),
				headUrl: require('../../../static/img/index_head.png'),
				robotSrc: require('../../../static/img/xyRobot.png'),
				titleUrl: require('../../../static/img/title.png'),
				error_ul: require('../../../static/img/error-list.png'),
				error_li: require('../../../static/img/error-code.png'),
				robot_ul: require('../../../static/img/robot-ul.png'),
				robot_li: require('../../../static/img/robot-li.png'),
				backUrl: '',
				mapAry: [],
				robotAry: [],
				mapRobotAry: [],
				mapRobotColor: ['#FF6600', '#FFFF66', '#336699', '#CC6699', '#FF9933', '#FFFFCC', '#009966', '#663300'],
				vWidth: 0,
				vHeight: 0,
				errorData: {
					totalNum: 0,
					untreatedNum: 0,
					percen: 0,
				},
				eventAry: [],
				errorObj: {
					onDuty: 0,
					totalNum: 0
				},
				showScrollBtn: false,
				ifMapList: false,
				mapScale: 1,
				funNum: 0,
				funReal: 0,
				checkMap: {}
			}
		},
		mounted() {
			// 定时执行保持token有效
			let that = this
			setInterval(() => {
				that.newTime = new Date()
			}, 1000)
			let tenID = that.$route.query.tenantInfoId
			setToken(that.$route.query.token)
			// let tenID = getItem('tenantInfoId')
			setTimeout(function() {
				that.mapEventChart(tenID)
				that.eventChart(tenID)
			}, 500)
			setTimeout(function() {
				that.allEventStatistics(tenID)
				that.mapList(tenID)
				that.robotList(tenID)
				that.eventList(tenID)
				that.robotNum(tenID)
				that.mapEventLineChart(tenID)
				that.eventLineChart(tenID)
				that.handleTime(tenID)
				that.runTime(tenID)
			},200)
		},
		updated() {
			let that = this
			if (that.$refs.robot && that.$refs.robot.length > 0) {
				that.$refs.robot.map((v, index) => {
					v.style.top = Number(that.mapRobotAry[index].positon.split(',')[1]) - 10 + 'px'
					v.style.left = Number(that.mapRobotAry[index].positon.split(',')[0]) - 10 + 'px'
				})
			}
		},
		methods: {
			doSocker(socketData) {},
			// doSocker(socketData) {
			// 	let that = this
			// 	if (socketData.socketType === '1') {
			// 		if (that.checkMap.number === socketData.map) {
			// 			let mapRobotList = []
			// 			that.mapRobotAry.map(v => {
			// 				mapRobotList.push(v.robotId)
			// 				if (v.robotId === socketData.robotId) {
			// 					v.positon = socketData.positon
			// 				}
			// 			})
			// 			if (mapRobotList.indexOf(socketData.robotId) === -1) {
			// 				that.mapRobotAry.push({
			// 					area: socketData.area,
			// 					floor: socketData.floor,
			// 					map: socketData.map,
			// 					number: socketData.fromUserId,
			// 					positon: socketData.positon,
			// 					robotId: socketData.robotId,
			// 					ststus: socketData.ststus,
			// 					ststusName: socketData.ststusName
			// 				})
			// 			}
			// 		}
			// 		for (let i = 0; i < that.robotAry.length; i++) {
			// 			if (that.robotAry[i].robotId === socketData.robotId) {
			// 				that.robotAry[i].ststusName = socketData.ststusName
			// 			}
			// 		}
			// 		that.robotAry = JSON.parse(JSON.stringify(that.robotAry))
			// 		that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
			// 	} else if (socketData.socketType === '2' || socketData.socketType === '4' || socketData.socketType ===
			// 		'6' || socketData.socketType === '7') {
			// 		if (socketData.socketType === '7' && socketData.onlineStatus === '2') {
			// 			that.mapRobotAry.forEach((v, index) => {
			// 				if (v.robotId === socketData.robotId) {
			// 					that.mapRobotAry.splice(index, 1)
			// 				}
			// 			})
			// 			that.mapRobotAry = JSON.parse(JSON.stringify(that.mapRobotAry))
			// 		}
			// 		let tenID = getItem('tenantInfoId')
			// 		that.mapEventChart(tenID)
			// 		that.eventChart(tenID)
			// 		that.allEventStatistics(tenID)
			// 		that.mapEventLineChart(tenID)
			// 		that.eventLineChart(tenID)
			// 		that.eventList(tenID)
			// 		that.robotList(tenID)
			// 		that.robotNum(tenID)
			// 	}
			// },
			mapScroll(type) {
				let leftData = document.getElementsByClassName('changeImage')[0].scrollLeft
				if (type === 'left') {
					document.getElementsByClassName('changeImage')[0].scrollLeft = leftData - 100
				} else {
					document.getElementsByClassName('changeImage')[0].scrollLeft = leftData + 100
				}
			},
			runTime(id) {
				let that = this
				runTime(id).then(res => {
					if (res.data && res.data.days) {
						that.funNum = Number(res.data.days) * 24
						that.funReal = Number(res.data.days)
					}
				})
			},
			getMapDetail(index) {
				let that = this
				that.mapAry.map(v => {
					v.check = false
				})
				that.mapAry[index].check = true
				that.checkMap = that.mapAry[index]
				that.mapAry = JSON.parse(JSON.stringify(that.mapAry))
				that.backUrl = that.mapAry[index].address
				that.vWidth = Number(that.mapAry[index].width)
				that.vHeight = Number(that.mapAry[index].height)
				this.computedScale()
				// positonList({
				// 	number: that.mapAry[index].number,
				// 	userId: getItem('userInfo').staffId
				// }).then(res => {
				// 	if (res && res.data.length > 0) {
				// 		that.mapRobotAry = res.data
				// 	} else {
				// 		that.mapRobotAry = []
				// 	}
				// })
			},
			robotNum(id) {
				let that = this
				robotNum(id).then(res => {
					that.errorObj = res.data
					if (!that.errorObj.onDuty) {
						that.errorObj.onDuty = 0
					}
					if (!that.errorObj.totalNum) {
						that.errorObj.totalNum = 0
					}
				})
			},
			mapEventChart(id) {
				let that = this
				mapEventChart(id).then(res => {
					that.Echarts2(res.data)
				})
			},
			eventChart(id) {
				let that = this
				eventChart(id).then(res => {
					that.Echarts3(res.data)
				})
			},
			eventList(id) {
				let that = this
				eventList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.eventAry = res.data
					} else {
						that.eventAry = []
					}
				})
			},
			mapEventLineChart(id) {
				let that = this
				mapEventLineChart(id).then(res => {
					that.Echarts21(res.data)
				})
			},
			eventLineChart(id) {
				let that = this
				eventLineChart(id).then(res => {
					that.Echarts31(res.data)
				})
			},
			handleTime(id) {
				let that = this
				handleTime(id).then(res => {
					that.Echarts0(res.data)
				})
			},
			robotList(id) {
				let that = this
				robotList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.robotAry = res.data
					} else {
						that.robotAry = []
					}
				})
			},
			mapList(id) {
				let that = this
				mapList(id).then(res => {
					if (res.data && res.data.length > 0) {
						that.mapAry = res.data
						that.mapAry.map(v => {
							v.check = false
						})
						that.backUrl = that.mapAry[0].address
						that.vWidth = Number(that.mapAry[0].width)
						that.vHeight = Number(that.mapAry[0].height)
						that.getMapDetail(0)
					} else {
						that.mapAry = []
					}
				})
			},
			allEventStatistics(id) {
				let that = this
				allEventStatistics(id).then(res => {
					if (res.data) {
						that.errorData = res.data
						that.errorData.percen = (that.errorData.untreatedNum / that.errorData.totalNum) * 100
					}
				})
			},
			Echarts0(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li0'))
				myChart.clear();
				let datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '事件处理时效分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['rgb(254,84,84)','rgb(255,192,70)', 'rgb(209,72,254)','rgb(50,186,254)', 'red', 'yellow', 'green'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'black',
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			Echarts21(echarArray) {
				let that = this
				var myChart = this.$echarts.init(document.getElementById('body-li2-2'))
				myChart.clear();
				echarArray.mapEvent.forEach((v, index) => {
					v.type = "line"
					// v.itemStyle = {
					//     normal: {
					//         lineStyle: {
					//             color: that.mapRobotColor[index]
					//         }
					//     }
					// }
				})

				var option = {
					title: {
						show: true,
						text: '近七日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'axis'
					},
					// legend: {
					//   data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
					// },
					grid: {
						top: '10%',
						left: '2%',
						right: '1%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							rotate: 40
						},
						data: echarArray.date
					},
					yAxis: {
						type: 'value'
					},
					series: echarArray.mapEvent
				};
				myChart.setOption(option)
			},
			Echarts2(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li2'))
				myChart.clear();
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '当日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					grid: {
						left: '5%',
						right: '4%',
						bottom: '10%',
						top: '50%'
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['#FF6600', '#FFFF66', 'blue', '#009966', '#FF9933', '#FFFFCC', '#009966', '#336699', '#663300'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'black'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			Echarts31(echarArray) {
				let that = this
				var myChart = this.$echarts.init(document.getElementById('body-li3-2'))
				myChart.clear();
				echarArray.event.forEach((v, index) => {
					v.type = "line"
					// v.itemStyle = {
					//     normal: {
					//         lineStyle: {
					//             color: that.mapRobotColor[index]
					//         }
					//     }
					// }
				})
				var option = {
					title: {
						show: true,
						text: '近七日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'axis'
					},
					grid: {
						top: '10%',
						left: '5%',
						right: '1%',
						bottom: '15%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: false,
						axisLabel: {
							rotate: 40
						},
						data: echarArray.date
					},
					yAxis: {
						type: 'value'
					},
					series: echarArray.event
				};
				myChart.setOption(option)
			},
			Echarts3(echarArray) {
				var myChart = this.$echarts.init(document.getElementById('body-li3'))
				myChart.clear();
				echarArray.map(v => {
					v.value = Number(v.number)
				})
				var datas = [echarArray]
				var option = {
					title: {
						show: true,
						text: '当日分析',
						y: 'bottom',
						x: 'center',
						textStyle: {
							color: 'white'
						}
					},
					tooltip: {
						trigger: 'item',
						formatter: '{b}: {c} ({d}%)'
					},
					series: datas.map(function(data, idx) {
						return {
							type: 'pie',
							radius: [30, '60%'],
							center: ["50%", "45%"],
							// itemStyle: {
							//     normal: {
							//         color(params) {
							//             var colorList = ['#99CCFF','#FFCC33','#FFFF33','#0000CC','#333333', '#333300'];
							//             return colorList[params.dataIndex]
							//         }
							//     }
							// },
							label: {
								alignTo: 'edge',
								formatter: '{time|{c}}\n{name|{b}}',
								edgeDistance: 5,
								lineHeight: 20,
								rich: {
									time: {
										fontSize: 15
									},
									textStyle: {
										color: 'gray'
									}
								}
							},
							labelLine: {
								length: 5,
								length2: 0,
								maxSurfaceAngle: 80
							},
							labelLayout: function(params) {
								var isLeft = params.labelRect.x < myChart.getWidth() / 2
								var points = params.labelLinePoints
								points[2][0] = isLeft ? params.labelRect.x : params.labelRect.x + params
									.labelRect.width
								return {
									labelLinePoints: points
								}
							},
							data: data
						}
					})
				}
				myChart.setOption(option)
			},
			computedScale() {
				this.mapScale = 1
				this.$nextTick().then(() => {
					let oW = this.$refs.adressWrap.offsetWidth
					let oH = this.$refs.adressWrap.offsetHeight
					if (this.vWidth != oW || this.vHeight != oH) {
						let wScale = oW / this.vWidth
						let hScale = oH / this.vHeight
						this.mapScale = Math.min(wScale, hScale);
					}
				})
			}
		},
		watch: {
			// newTime: {
			// 	deep: true,
			// 	immediate: true,
			// 	handler(newData, oldData) {
			// 		let that = this
			// 		if (getToken()) {
			// 			let tenID = getItem('tenantInfoId')
			// 			if (newData.getMinutes() === 0 && newData.getSeconds() === 0) {
			// 				that.runTime(tenID)
			// 				that.handleTime(tenID)
			// 			}
			// 		}
			// 	}
			// }
		}
	}
</script>



// WEBPACK FOOTER //
// src/page/phone/index1.vue